import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FieldLabel } from '@puckeditor/core';
import { useIntl } from 'react-intl';
import { Input, Button } from 'reactstrap';

import RadioField from './RadioField';

const normalizeValue = (value) => ({
  title: value?.title || '',
  subtitle: value?.subtitle || '',
  align: value?.align || 'left',
});

const SectionHeadingField = ({
  value,
  onChange,
  field,
  readOnly,
}) => {
  const intl = useIntl();
  const heading = normalizeValue(value);
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (key, nextValue) => {
    onChange({
      ...heading,
      [key]: nextValue,
    });
  };

  return (
    <div className="puck-section-heading-field">
      <Button
        color="link"
        className="puck-section-heading-field-toggle"
        onClick={() => setIsOpen(prev => !prev)}
        disabled={readOnly}
      >
        <span className="puck-section-heading-field-toggle-label">{field.label}</span>
        <i className={`far ${isOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
      </Button>

      {isOpen && (
        <div className="puck-section-heading-field-body">
          <FieldLabel label={intl.formatMessage({ defaultMessage: 'Title' })}>
            <Input
              type="text"
              bsSize="sm"
              className="mb-2"
              value={heading.title}
              onChange={e => handleChange('title', e.target.value)}
              disabled={readOnly}
            />
          </FieldLabel>

          <FieldLabel label={intl.formatMessage({ defaultMessage: 'Subtitle' })}>
            <Input
              type="text"
              bsSize="sm"
              className="mb-2"
              value={heading.subtitle}
              onChange={e => handleChange('subtitle', e.target.value)}
              disabled={readOnly}
            />
          </FieldLabel>

          <RadioField
            id="puck-section-heading-align"
            label={intl.formatMessage({ defaultMessage: 'Align' })}
            value={heading.align}
            onChange={nextValue => handleChange('align', nextValue)}
            options={[
              { label: intl.formatMessage({ defaultMessage: 'Left' }), value: 'left' },
              { label: intl.formatMessage({ defaultMessage: 'Center' }), value: 'center' },
              { label: intl.formatMessage({ defaultMessage: 'Right' }), value: 'right' },
            ]}
            readOnly={readOnly}
          />
        </div>
      )}
    </div>
  );
};

SectionHeadingField.propTypes = {
  value: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    align: PropTypes.oneOf(['left', 'center', 'right']),
  }),
  onChange: PropTypes.func.isRequired,
  field: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
  readOnly: PropTypes.bool,
};

SectionHeadingField.defaultProps = {
  value: {
    title: '',
    subtitle: '',
    align: 'left',
  },
  readOnly: false,
};

export default SectionHeadingField;
